import { Navigate, Route, Routes } from 'react-router-dom'
import { Layout } from './components/Layout'
import AboutPage from './pages/AboutPage'
import AppsPage from './pages/AppsPage'
import ArticlePage from './pages/ArticlePage'
import BookingPage from './pages/BookingPage'
import CommunityPage from './pages/CommunityPage'
import EditorialPolicyPage from './pages/EditorialPolicyPage'
import HomePage from './pages/HomePage'
import InsightsPage from './pages/InsightsPage'
import NotFoundPage from './pages/NotFoundPage'
import PrivacyPage from './pages/PrivacyPage'
import ResearchPage from './pages/ResearchPage'

function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="insights" element={<InsightsPage />} />
          <Route path="insights/:slug" element={<ArticlePage />} />
          <Route path="apps" element={<AppsPage />} />
          <Route path="booking" element={<BookingPage />} />
          <Route path="research" element={<ResearchPage />} />
          <Route path="community" element={<CommunityPage />} />
          <Route path="privacy" element={<PrivacyPage />} />
          <Route path="editorial-policy" element={<EditorialPolicyPage />} />
          <Route path="home" element={<Navigate to="/" replace />} />
          <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  )
}

export default App
